/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * UploadArea mit Material UI
 * 
 * Mit dieser Komponente können Bilder, Videos oder PDF-Dokumente in das /resources-Verzeichnis
 * hochgeladen werden. Jedes Objekt wird je nach Datei-Typ in einem eigenen Unterverzeichnis 
 * abgelegt.  
 *
 */

import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DropzoneArea } from 'material-ui-dropzone';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import MovieIcon from '@material-ui/icons/Movie';

import * as utils from "../../basics/utils";
import * as appActions from "../../store/actions/appActions";
import * as fileActions from "../../store/actions/fileActions";
import * as portfolioActions from '../../store/actions/portfolioActions';
import * as settingActions from '../../store/actions/settingActions';
class UploadArea extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'UploadArea';

        this.debug = false;
    }


    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { path } = this.props.app;
        const { file } = this.props;
        const { uploadArea, uploadType, uploadPath, uploadPost, onUploadCallback } = this.props;


        const onAlert = (message, variant) => {
            this.props.uploadFileError(message);
            //this.props.setModalDialog('ConfirmModal', 'uploadError');
        }

        // ==========================================================================                         
        // Zentrale Upload-Funktion
        // ==========================================================================                                      
        const onUpload = (files) => {
            if (file.progress) return;

            if (files.length === 0) return;

            const dialog = utils.getDialogByPath(path);
            this.debug && console.log('onUpload() dialog:', dialog);

            // --------------------------------------------------------------------------                         
            // Formular-Objekt erstellen und aktuelle UploadDatei hinzufügen 
            // --------------------------------------------------------------------------                         
            const formData = new FormData();
            const currentFile = files[0];
            formData.append("file", currentFile);

            let uploadSize = currentFile.size;
            let uploadName = currentFile.name;
            let fileDetails = utils.getFileDetails(uploadName);

            this.props.setModalDialog('UploadModal', null, fileDetails);

            // --------------------------------------------------------------------------                         
            // Upload-Callbacks 
            // --------------------------------------------------------------------------                         
            const onUploadSuccess = (data) => {
                this.debug && console.log('onUploadSuccess() data:', data);

                this.props.setModalDialog(null, null);

                this.props.setCoverEdit(false);

                if (dialog.portfolio) {
                    setTimeout(() => {
                        this.props.scanPortfolio(dialog.portfolio)
                        if (utils.isFunction(onUploadCallback)) {
                            onUploadCallback(uploadName);
                        }
                    }, 500);
                }
            }

            const onUploadError = (error) => {
                this.debug && console.log('onUploadError()', error);
                setTimeout(() => {
                    this.props.setModalDialog(null, null);

                    this.props.setCoverEdit(false);

                    if (fileDetails.ext === 'mp4') {
                        // Falls ein Video-Upload abgebrochen wurde, dann
                        // muss die Video-Datei auch im Portfolio-Verzeichnis gelöscht werden.
                        this.props.deleteFile(uploadType, uploadPath, uploadName);
                    }
                }, 5000);
            }

            const onUploadProgress = (e) => {
                this.debug && console.log(`onUploadProgress( ${e.loaded} of ${e.total})`);
            }


            // --------------------------------------------------------------------------                         
            // Wird uploadPostfix als Parameter übergeben, dann wird der Dateiname durch
            // diesen uploadPostfix ergänzt. Die file-Extention wird aus dem ursprümglichen
            // Dateinamen übernommen.
            // --------------------------------------------------------------------------              
            if (uploadPost !== '') {
                uploadName = fileDetails.name + '_' + uploadPost + '.' + fileDetails.ext;
            }

            // --------------------------------------------------------------------------                         
            // Bei Videos wird der Dateiname wie folgt zusammengestellt
            // [name]_[size].[extention]
            // --------------------------------------------------------------------------                         
            if (fileDetails.ext === 'mp4') {
                uploadName = uploadSize + '_' + fileDetails.name + '.' + fileDetails.ext;
            }

            // --------------------------------------------------------------------------                         
            // 
            // 
            // --------------------------------------------------------------------------                         
            if (uploadType === 'common') {
                uploadName = 'catalog_image.png';
            }

            // --------------------------------------------------------------------------                         
            // 
            // 
            // --------------------------------------------------------------------------                         
            if (uploadArea === 'images') {
                const timestamp = utils.getDateTime(new Date());
                uploadName = `image_${timestamp}_${fileDetails.name}.${fileDetails.ext}`
            }

            if (this.debug) {
                console.log('currentFile:', currentFile.name);
                console.log('uploadType:', uploadType);
                console.log('uploadPath:', uploadPath);
                console.log('uploadPost:', uploadPost);
                console.log('uploadSize:', uploadSize);
                console.log('uploadName:', uploadName);
            }

            // --------------------------------------------------------------------------                         
            // upload durchführen
            // --------------------------------------------------------------------------                         
            this.props.uploadFile(uploadType, uploadPath, uploadName, formData, onUploadSuccess, onUploadError, onUploadProgress); // fileAction.js
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        // ---------------------------------                
        // Bedingungen für Upload festlegen
        // ---------------------------------                

        let maxFileSize = parseInt(process.env.REACT_APP_MAX_FILE_SIZE) * 1024 * 1024;
        //let maxFileSize = parseInt(100) * 1024 * 1024; // Test
        let icon = null;
        let text = "drag & drop image"
        let acceptedFiles = ['image/png', 'image/jpeg'];

        // Bedingungen für PDF-Dokumente
        if (uploadArea === 'pdf') {
            icon = PictureAsPdfIcon;
            text = "drag & drop PDF";
            acceptedFiles = ['application/pdf'];
        }

        // Bedingungen für Videos
        if (uploadArea === 'video') {
            icon = MovieIcon;
            text = "drag & drop video";
            acceptedFiles = ['video/mp4']
        }

        return (
            <div className="w-full h-full">
                <DropzoneArea
                    Icon={icon}
                    acceptedFiles={acceptedFiles}
                    filesLimit={1}
                    showAlerts={false}
                    showPreviews={false}
                    showPreviewsInDropzone={false}
                    maxFileSize={maxFileSize}
                    dropzoneText={text}
                    onChange={(files) => onUpload(files)}
                    onAlert={onAlert}
                />

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        setting: state.setting,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions, settingActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadArea);
